/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const PortfolioTearsheetPage = lazyLoad(
  () => import('./index'),
  module => module.PortfolioTearsheetPage,
);
